import React, { useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import UserSelector from "utils/UserSelector";
import CustomFormCheck from "utils/CustomFormCheck";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

export default function PointsOfContact(props) {
  let initialDate = undefined
  if (props.group === "ppc" && props.billing_config.ppc_start_date !== null) initialDate = new Date(props.billing_config.ppc_start_date);
  if (props.group === "seo" && props.billing_config.seo_start_date !== null) initialDate = new Date(props.billing_config.seo_start_date);
  
  const calendarForm = () => {
    const [startDate, setStartDate] = useState(
      initialDate
        ? initialDate
        : props.onboarding && props.startDate === undefined
        ? undefined
        : props.onboarding && props.startDate !== undefined
        ? new Date(props.startDate)
        : undefined
    );

    const calendarRef = useRef()

    return (
      <>
        <div className="d-flex">
          <div className="dateSelector">
            <i
              onClick={() => {
                calendarRef.current.setOpen(true);
              }}
              className="far f20 fa-calendar-alt"></i>

            <DatePicker
              ref={calendarRef}
              utcOffset="0"
              autoComplete="off"
              dateFormat="MM/dd/yy"
              selected={startDate}
              onChange={(date) => {
                if (props.onboarding) {
                  props.setStartDate((e) => date), setStartDate((e) => date);
                }
                setStartDate(date);
              }}
              name={`${props.group}_start_date`}
            />
          </div>
        </div>
      </>
    );
  };
  let labelCheck = false;
  if (props.group == "seo") {
    labelCheck = props.seo_section.white_label_service;
  }
  if (props.group == "ppc") {
    labelCheck = props.search_section.white_label_service;
  }

  const [checkLabel, setCheckLabel] = useState(labelCheck);
  return (
    <>
      <div className="py-3 my-4" style={{ backgroundColor: "#e1e1e1", paddingLeft: "10px", paddingRight: "10px" }}>
        <Row className="mb-3">
          <Col>
            <div>
              <p className="mb-1 primary f14 visby-bold pl-3">{props.onboarding ? "Choose Date" : "Start Date"}</p>
              {calendarForm()}
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <CustomFormCheck
              id={`${props.group}-poc-white-label`}
              className="f16"
              name={`${props.group}_section[white_label_service]`}
              label={`White label ${props.group.toUpperCase()}`}
              checked={checkLabel}
              onChange={() => {
                props.setPpcWhiteLabelService && props.setPpcWhiteLabelService(!checkLabel);
                props.setSeoWhiteLabelService && props.setSeoWhiteLabelService(!checkLabel);
                setCheckLabel(!checkLabel);
              }}
            />
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            <p className="mb-1 primary f14 visby-bold">Point(s) of Contact</p>
            <UserSelector
              modalHeader={`${props.client_company.company_name} - Select Points of contact`}
              users={props.users}
              defaultValue={props.group == "seo" ? props.client_account.seo_points_of_contact : props.client_account.ppc_points_of_contact}
              fieldsForArray={["points_of_contact", props.group]}
              setServiceAccount={props.group == "seo" ? props.setSeoPointsOfContact : props.setPpcPointsOfContact}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <p className="mb-1 primary f14 visby-bold">Account Lead(s)</p>
            {props.group === "ppc" ? (
              <p className="primary f12 mb-3 nunito-regular">Refer to indiviudal PPC services below</p>
            ) : props.group === "seo" ? (
              <UserSelector
                setServiceAccount={props.setSeoAccountLeads}
                modalHeader={`${props.client_company.company_name} - Select SEO Account Leads`}
                users={props.users}
                defaultValue={props.seo_section.account_leads}
                fieldsForArray={["supporting_roles", "seo", "account_leads"]}
              />
            ) : (
              <p>wrong group input - must be `seo` or `ppc`</p>
            )}
            <p className="mb-1 primary f14 visby-bold">Account Support</p>
            {props.group === "ppc" ? (
              <p className="primary f12 mb-3 nunito-regular">Refer to indiviudal PPC services below</p>
            ) : props.group === "seo" ? (
              <UserSelector
                setServiceAccount={props.setSeoAccountSupports}
                modalHeader={`${props.client_company.company_name} - Select SEO Account Support`}
                users={props.users}
                defaultValue={props.seo_section.account_supports}
                fieldsForArray={["supporting_roles", "seo", "account_support"]}
              />
            ) : (
              <p>wrong group input - must be `seo` or `ppc`</p>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}
